module.exports = __webpack_public_path__ + "static/media/register.55f55591.jpeg";